import React, { useContext, useEffect, useState } from 'react';
import { Route, useHistory } from 'react-router-dom';
import { KeycloakContext } from '../store/index';
import { checkExpiresToken, refreshToken } from '../services/authentication';
import Loader from '../components/Loader';

export default function PrivateRoute({ children, session, ...rest }) {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const { keycloak } = useContext(KeycloakContext);

  useEffect(() => {
    if (session) {
      let isExpiredToken = checkExpiresToken(keycloak);

      if (!isExpiredToken) {
        refreshToken(session.clientId, 'refresh_token', session.refreshToken);
      }
    } else {
      history.push('/login');
    }

    setIsLoading(false)
  }, [])

  return (
    isLoading ? <Loader /> : <Route {...rest} component={() => children} />
  );
}
